module.exports = __webpack_public_path__ + "img/Fintech-network-en.f0ccc1a5.png";